import React, { useState } from 'react';
import './ReferencesSection.css';
import { useLanguage } from '../../../context/LanguageContext';

const ReferencesSection: React.FC = () => {
  const { t } = useLanguage();
  const [flippedCards, setFlippedCards] = useState<Set<number>>(new Set());
  const references = [
    {
      id: 1,
      name: "SARITAŞ MAKİNA",
      description: "Makine üreticisi",
      logo: "fas fa-industry",
      category: "Üretici Partner",
      year: "2010",
    },
    {
      id: 2,
      name: "GAYSAN OTOMOTİV",
      description: "Otomotiv tedarikçisi",
      logo: "fas fa-car",
      category: "Üretici Partner",
      year: "2015",
    },
    {
      id: 3,
      name: "TEKNİK MAKİNA",
      description: "Makine ve ekipman",
      logo: "fas fa-cogs",
      category: "Tedarikçi Partner",
      year: "2012",
    },
    {
      id: 4,
      name: "SUNEX ENGINE VALVES",
      description: "Motor supap üreticisi",
      logo: "fas fa-wrench",
      category: "Tedarikçi Partner",
      year: "2018",
    },
  ];

  const toggleCard = (index: number) => {
    const newFlippedCards = new Set(flippedCards);
    if (newFlippedCards.has(index)) {
      newFlippedCards.delete(index);
    } else {
      newFlippedCards.add(index);
    }
    setFlippedCards(newFlippedCards);
  };

  return (
    <section id="references" className="references">
      <div className="container">
        {/* Section Header */}
        <div className="references__header">
          <div className="references__header-content">
            <span className="references__subtitle">{t('references.subtitle')}</span>
            <h2 className="references__title">{t('references.title')}</h2>
            <p className="references__description">
              {t('references.desc')}
            </p>
          </div>
        </div>

        {/* References Grid */}
        <div className="references__grid">
          {references.map((reference, index) => (
            <div 
              key={index} 
              className="references__card" 
              style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}
            >
              <div 
                className={`references__card-inner ${flippedCards.has(index) ? 'flipped' : ''}`}
                onClick={() => toggleCard(index)}
              >
                <div className="references__card-front">
                  <div className="references__logo">
                    <i className={reference.logo}></i>
                  </div>
                  <h3 className="references__name">{reference.name}</h3>
                  <p className="references__category">{reference.category}</p>
                  <div className="references__year">
                    <span>{t('references.since')}</span>
                    <strong>{reference.year}</strong>
                  </div>
                </div>
                <div className="references__card-back">
                  <div className="references__details">
                    <h4>{reference.name}</h4>
                    <p>{reference.description}</p>
                    <div className="references__stats">
                      <div className="references__stat">
                        <span className="references__stat-number">
                          {2024 - parseInt(reference.year)}+
                        </span>
                        <span className="references__stat-label">{t('references.years')}</span>
                      </div>
                      <div className="references__stat">
                        <span className="references__stat-number">100+</span>
                        <span className="references__stat-label">{t('references.projects')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="references__bottom">
          <div className="references__achievements">
            <div className="references__achievement">
              <div className="references__achievement-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <div className="references__achievement-content">
                <h4>{t('references.ach.partners')}</h4>
                <p>{t('references.ach.partners.desc')}</p>
              </div>
            </div>
            <div className="references__achievement">
              <div className="references__achievement-icon">
                <i className="fas fa-award"></i>
              </div>
              <div className="references__achievement-content">
                <h4>{t('references.ach.satisfaction')}</h4>
                <p>{t('references.ach.satisfaction.desc')}</p>
              </div>
            </div>
            <div className="references__achievement">
              <div className="references__achievement-icon">
                <i className="fas fa-globe"></i>
              </div>
              <div className="references__achievement-content">
                <h4>{t('references.ach.nationwide')}</h4>
                <p>{t('references.ach.nationwide.desc')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferencesSection;
